import {useState} from "react";
import {WaitingQueueInfo} from "../logic/types/waitingQueue.types";
import {useRegisterWaitingQueueMutation} from "../logic/quries/waitingQueue.queries";

export const useRegisterQueue = () => {
  const [error, isError] = useState<string>("");

  const registerWaitingQueueMutation = useRegisterWaitingQueueMutation();

  const registerQueue = async (): Promise<WaitingQueueInfo> => {
    try {
      const response = await registerWaitingQueueMutation.mutateAsync();
      return response;
    } catch (error) {
      console.error(error);
      isError("error");
      throw error;
    }
  };

  return {registerQueue, error};
};
